import { UserSettingOption } from '@enums';
import { UserSettingOptionState } from '@model';
import { Action } from '@ngrx/store';

export enum FilterViewSettingActionTypes {

  AnalyzeFilterViewSettingLoad = '[AnalyzeFilterViewSetting] setting load',
  AnalyzeFilterViewSettingLoadSuccess = '[AnalyzeFilterViewSetting] setting load success',
  AnalyzeFilterViewSettingLoadFail = '[AnalyzeFilterViewSetting] setting load fail',

  AnalyzeFilterViewSettingUpdate = '[AnalyzeFilterViewSetting] setting Update',
  AnalyzeFilterViewSettingUpdateSuccess = '[AnalyzeFilterViewSetting] setting Update success',
  AnalyzeFilterViewSettingUpdateFail = '[AnalyzeFilterViewSetting] setting Update fail'
}

export class AnalyzeFilterViewSettingLoad implements Action {
  readonly type = FilterViewSettingActionTypes.AnalyzeFilterViewSettingLoad;
  constructor() {}
}
export class AnalyzeFilterViewSettingLoadSuccess implements Action {
  readonly type = FilterViewSettingActionTypes.AnalyzeFilterViewSettingLoadSuccess;
  constructor(public payload: UserSettingOptionState) {}
}
export class AnalyzeFilterViewSettingLoadFail implements Action {
  readonly type = FilterViewSettingActionTypes.AnalyzeFilterViewSettingLoadFail;
  constructor(public payload: any) {}
}

export class AnalyzeFilterViewSettingUpdate implements Action {
  readonly type = FilterViewSettingActionTypes.AnalyzeFilterViewSettingUpdate;
  constructor(public payload: UserSettingOptionState) {}
}
export class AnalyzeFilterViewSettingUpdateSuccess implements Action {
  readonly type = FilterViewSettingActionTypes.AnalyzeFilterViewSettingUpdateSuccess;
  constructor(public payload: UserSettingOptionState) {}
}
export class AnalyzeFilterViewSettingUpdateFail implements Action {
  readonly type = FilterViewSettingActionTypes.AnalyzeFilterViewSettingUpdateFail;
  constructor(public payload: any) {}
}

export type FilterViewSettingActions =
  | AnalyzeFilterViewSettingLoad
  | AnalyzeFilterViewSettingLoadSuccess
  | AnalyzeFilterViewSettingLoadFail
  | AnalyzeFilterViewSettingUpdate
  | AnalyzeFilterViewSettingUpdateSuccess
  | AnalyzeFilterViewSettingUpdateFail;
